import React from "react";
import { Collapse } from "antd";
import { AiOutlineUp, AiOutlineDown } from "react-icons/ai";
import "./Faq.css";
import { useTranslation } from "react-i18next";

const Faq = () => {
  const { t } = useTranslation();
  const panelStyle = {
    marginBottom: -10,
    background: "#151d4e",
    border: "none",
    boxShadow: "20px 24px 30px 7px rgba(0,0,0, 0.06)",
  };
  const getItems = (panelStyle) => [
    {
      key: "1",
      label: `${t("What")} ${t("is")} Sportex Gamers Wallet?`,
      children: (
        <p className="collapse-answer">
          Sportex Gamers Wallet {t("is")} {t("a")} {t("multichain")}{" "}
          {t("gamers")} {t("wallet")} {t("that")} {t("allows")} {t("users")}{" "}
          {t("to")} {t("store")}, {t("manage")}, {t("and")} {t("transact")}{" "}
          {t("with")} {t("their")} {t("gaming")} {t("assets")} {t("across")}{" "}
          {t("multiple")} {t("blockchains")}. {t("It")} {t("is")} {t("a")}{" "}
          {t("convenient")} {t("and")} {t("secure")} {t("way")} {t("for")}{" "}
          {t("gamers")} {t("to")} {t("manage")} {t("their")} {t("assets")}{" "}
          {t("and")} {t("participate")} {t("in")} {t("the")} {t("Web3")}{" "}
          {t("gaming")} {t("ecosystem")}.{" "}
        </p>
      ),
      style: panelStyle,
    },
    {
      key: "2",
      label: `${t("What")} ${t("blockchains")} ${t(
        "does"
      )} Sportex Gamers Wallet ${t("support")}?`,
      children: (
        <p className="collapse-answer">
          Sportex Gamers Wallet {t("currently")} {t("supports")} {t("the")}{" "}
          {t("following")} {t("blockchains")}: Ethereum, {t("and")} Binance
          Smart Chain. {t("More")} {t("blockchains")} {t("will")}
          {t("be")} {t("added")} {t("in")} {t("the")} {t("future")}.{" "}
        </p>
      ),
      style: panelStyle,
    },
    {
      key: "3",
      label: `${t("What")} ${t("types")} ${t("of")} ${t("gaming")} ${t(
        "assets"
      )} ${t("can")} ${t("I")} ${t("store")} ${t("in")} Sportex Gamers Wallet?`,
      children: (
        <p className="collapse-answer">
          Sportex Gamers Wallet {t("can")} {t("be")} {t("used")} {t("to")}{" "}
          {t("store")} {t("different")} {t("gaming")} {t("assets")},{" "}
          {t("including")} NFTs, {t("in")}-{t("game")} {t("tokens")},{t("and")}{" "}
          {t("cryptocurrencies")}. {t("This")} {t("makes")} {t("it")} {t("a")}{" "}
          {t("one")} - {t("stop")} {t("shop")} {t("for")} {t("gamers")}{" "}
          {t("to")} {t("manage")} {t("all")} {t("of")} {t("their")}{" "}
          {t("gaming")} {t("assets")}.{" "}
        </p>
      ),
      style: panelStyle,
    },
    {
      key: "4",
      label: `${t("How")} ${t("do")} ${t("I")} ${t("get")} ${t(
        "the"
      )} Sportex Gamers Wallet?`,
      children: (
        <p className="collapse-answer">
          {t("To")} {t("get")} {t("a")} Sportex Gamers Wallet, {t("you")}{" "}
          {t("can")} {t("visit")} {t("the")} {t("website")}{" "}
          <a href="##" target="_blank" rel="noreferrer">
            {t("here")}
          </a>{" "}
          {t("and")} {t("download")}. {t("It's")} {t("available")} {t("on")} iOS
          {t("and")} Android. {t("Once")} {t("you")} {t("have")} {t("created")}
          {t("an")} {t("account")}, {t("you")} {t("will")} {t("be")} {t("able")}{" "}
          {t("to")} {t("generate")} {t("your")} {t("wallet")}
          {t("address")} {t("and")} {t("start")} {t("storing")} {t("and")}{" "}
          {t("managing")} {t("your")} {t("gaming")} {t("assets")}.{" "}
        </p>
      ),
      style: panelStyle,
    },
    {
      key: "5",
      label: `${t("How")} ${t("do")}  ${t("I")} ${t("deposit")} ${t("and")} ${t(
        "withdraw"
      )} ${t("funds")} ${t("from")} ${t("my")} Sportrex Gamers Wallet?`,
      children: (
        <p className="collapse-answer">
          {t("To")} {t("deposit")} {t("funds")} {t("into")} {t("your")} Sportex
          Gamers Wallet, {t("simply")} {t("send")} {t("the")}
          {t("desired")} {t("amount")} {t("of")} {t("cryptocurrency")} {t("to")}{" "}
          {t("your")} {t("wallet")} {t("address")}. {t("To")} {t("withdraw")}
          {t("funds")}, {t("simply")} {t("select")} {t("the")} {t("desired")}{" "}
          {t("cryptocurrency")} {t("and")} {t("amount")}, {t("and")} {t("then")}
          {t("enter")} {t("the")} {t("recipient's")} {t("wallet")}{" "}
          {t("address")}.{" "}
        </p>
      ),
      style: panelStyle,
    },
    {
      key: "6",
      label: `${t("What")} ${t("token")} ${t("can")} ${t("be")} ${t(
        "earned"
      )} ${t("on")} Sportrex?`,
      children: (
        <p className="collapse-answer">
          {t("The")} “{t("private")} {t("sale")}” {t("of")} {t("the")} Sportrex{" "}
          {t("token")} (SPT) {t("will")} {t("take")} {t("place")} {t("on")}{" "}
          <a href="/">
            {" "}
            {t("our")} {t("platform")}
          </a>{" "}
          {t("while")} {t("the")} “{t("presale")}” {t("four")} (4){" "}
          {t("leading")}
          {t("launchpad")} {t("platform")} i.e: MEXC, CoinStore, Gate.io{" "}
          {t("and")} BitMart
          {t("respectively")} {t("which")} {t("will")} {t("accept")} {t("only")}{" "}
          USDT / BUSD {t("and")} {t("the")} {t("exchanges")}
          {t("native")} {t("tokens")} {t("as")} {t("would")} {t("be")}{" "}
          {t("advised")} {t("during")} {t("the")} {t("LaunchPad")}{" "}
          {t("campaign")}.{" "}
        </p>
      ),
      style: panelStyle,
    },
    {
      key: "7",
      label: `${t("Is")} Sportex Gamers Wallet ${t("safe")}?`,
      children: (
        <p className="collapse-answer">
          {t("Yes")}, Sportex Gamers Wallet's {t("smart")} {t("contract")}{" "}
          {t("is")} {t("audited")} {t("by")} {t("top")} {t("audit")}
          {t("firms")} {t("to")} {t("ensure")} {t("your")} {t("assets")}{" "}
          {t("are")} {t("protected")}.{" "}
        </p>
      ),
      style: panelStyle,
    },
  ];
  return (
    <div className="faq-container">
      <div className="faq-details">
        <h4>FAQ</h4>
        <div className="collapse-container">
          <Collapse
            accordion
            items={getItems(panelStyle)}
            bordered={false}
            expandIconPosition={"end"}
            defaultActiveKey={["0"]}
            className="collapse-design"
            expandIcon={({ isActive }) =>
              isActive ? (
                <AiOutlineUp className="collapse-icon" />
              ) : (
                <AiOutlineDown className="collapse-icon" />
              )
            }
          />
        </div>
      </div>
    </div>
  );
};

export default Faq;
